<template>
  <li class="cms-news-list-item">
    <div class="cms-news-list-item__header">
      <div class="cms-news-list-item__header-date">
        <span class="text-second-20">{{ $formatDateLong(date) }}</span>
        <svg-icon v-if="isPinned" icon="pin" />        
      </div>
      <img v-if="imageUrl"
           class="cms-news-list-item__img"
           :src="imageUrl" />
      <div class="cms-news-list-item__title" v-html="title"></div>
    </div>
    
    <div v-if="!!summary" v-html="summary"></div>
    
    <a class="cms-news-list-item__link"
       :href="generatedLinkUrl"
       :target="isDirectLink ? '_blank' : ''"
    >
      <span>{{ $res.Views.CmsNewsItem_ReadMore }}</span>
      <svg-icon icon="straight-arrows/right" viewBox="0 0 16 16"/>
    </a>
  </li>
</template>

<script>
import SvgIcon from "@/common/controls/SvgIconControl.vue";

export default {
  components: {
    SvgIcon,
  },
  props: {
    title: String,
    imageUrl: String,
    summary: String,
    isDirectLink: Boolean,
    generatedLinkUrl: String,
    date: String,
    isPinned: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.cms-news-list-item {
  display: flex;
  flex-flow: column;
  gap: 10px;

  padding: 20px 24px;
  background-color: #fff;
  border-radius: var(--border-radius-lg);
}

.cms-news-list-item__header {
  display: flex;
  flex-flow: column;
  gap: 5px;
}

.cms-news-list-item__header-date {
  display: flex;
  gap: 8px;
  align-items: center;
}

.cms-news-list-item__img {
  width: 450px;
  height: 170px;
  object-fit: cover;
  border-radius: var(--border-radius-lg);
}

.cms-news-list-item__title {
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
}

.cms-news-list-item__link {
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  display: flex;
  gap: 8px;
  align-items: center;
}

.text-second-20 {
  color: var(--second-20);
}
</style>